/* @flow */
import * as React from 'react';

import { mountModal } from 'lib/modal';
import BoxBody from 'components/BoxBody.jsx';
import CurrentUser from 'auth/CurrentUser';
import Dialog from 'components/Dialog.jsx';
import EventTracking from 'lib/EventTracking';
import TitleHeader from 'components/TitleHeader.jsx';
import Row from 'components/Row.jsx';
import IndividualMessageStarter from 'chat/components/IndividualMessageStarter.jsx';
import PotentialChatMember from 'entities/PotentialChatMember';
import PhoneCallModal from 'phoneCalls/components/PhoneCallModal.jsx';
import PhoneNumberDialer from 'phoneCalls/components/PhoneNumberDialer.jsx';
import DialerDirectAddModal from './DialerDirectAddModal.jsx';
import Glyph from 'components/Glyph.jsx';
import Text from 'components/Text.jsx';

import './styles/MakeACallModal.scss';

type Props = {
  onRequestHide?: ?Function,
};

type State = {
  inputValue: string,
};

class MakeACallModal extends React.Component<Props, State> {
  state: State = {
    inputValue: '',
  };
  hasDialer = () => {
    const user = CurrentUser.getUser();
    return user.canCallFromDialer();
  };
  startCall = (pcm: PotentialChatMember) => {
    EventTracking.tap('MakeACallModal', 'select_callee');
    const { onRequestHide } = this.props;
    mountModal(<PhoneCallModal calleeUuid={pcm.getUuid()} />, this);
    if (onRequestHide) {
      onRequestHide();
    }
  };
  isTypingNumber = () => {
    if (!this.hasDialer()) {
      return false;
    }
    const { inputValue } = this.state;
    const startsWithNumber = /^[0-9].*$/.exec(inputValue);
    const likelyTypingNumber = /^[(].*$/.exec(inputValue);
    return !!(startsWithNumber || likelyTypingNumber);
  };

  handleInputChange = (value: ?string) => {
    this.setState({ inputValue: value || '' });
  };

  renderNoResults = (query: string) => {
    const addNumber = () => {
      mountModal(
        // $FlowFixMe hideParent arg may be null
        <DialerDirectAddModal name={query} number="" hideParent={this.props.onRequestHide} />,
        this
      );
    };
    return (
      <div>
        <Row size="small">
          <a className="MakeACallModal-action" key="noResults" onClick={addNumber}>
            <Glyph size="xlarge" color="brand" name="plus-circle-stroke" />
            <Text size="medium" color="brand">
              Add and call {query}
            </Text>
          </a>
        </Row>
        <Text size="small" color="thunder">
          By proceeding, I confirm that the individual I am calling is over the age of 13.
        </Text>
      </div>
    );
  };
  render() {
    const hasDialer = this.hasDialer();
    const placeholder = hasDialer ? 'Dial a number or type a name' : 'Type a name';
    return (
      <Dialog
        size="medium"
        eventScreenName="MakeACallModal"
        className="MakeACallModal"
        onRequestHide={this.props.onRequestHide}>
        <BoxBody>
          <div className="MakeACallModal-header">
            <TitleHeader
              textAlign="center"
              title="Make a call"
              subtext="Connect with anyone with a phone number"
            />
          </div>
          {this.isTypingNumber() ? (
            <PhoneNumberDialer
              onRequestHide={this.props.onRequestHide}
              onInputChange={this.handleInputChange}
              inputValue={this.state.inputValue}
            />
          ) : (
            <IndividualMessageStarter
              onSelect={this.startCall}
              renderNoResults={hasDialer && this.renderNoResults}
              onInputChange={this.handleInputChange}
              placeholderText={placeholder}
              showPhoneCallStatus
            />
          )}
        </BoxBody>
      </Dialog>
    );
  }
}

export default MakeACallModal;
